import { Modal, Tabs, Box } from '@mantine/core'
import { useRouter } from 'next/router'

import { useQueryGetAllBookingInsurances } from '@flecto/core/saas'
import { type CoreInsurance } from '@flecto/types'

import { TableBookingInsurances } from '../../../booking-insurances'
import InsuranceProvider from '../../provider'
import { EKindTab, useInsuranceManagerState } from '../../state'
import { Header } from './components/Header'
import TabGeneral from './components/TabGeneral'
import classes from './InsuranceManager.module.css'

export function BookingInsuranceManager() {
  const router = useRouter()

  const bookingId = String(router.query.id ?? '')

  const { data: insurances, isLoading } = useQueryGetAllBookingInsurances({
    bookingId,
  })

  const { tab, setTab, isModalOpened, setModalOpened } =
    useInsuranceManagerState()

  const scheduleReset = () => {
    setModalOpened(false)

    // Avoid flickering when closing the modal
    setTimeout(() => {
      setTab(EKindTab.GENERAL)
    }, 500)
  }

  return (
    <Modal
      withCloseButton={false}
      onClose={scheduleReset}
      size={900}
      opened={isModalOpened}
      className={classes.modal}
      centered
      closeOnClickOutside
      closeOnEscape
    >
      <InsuranceProvider>
        <Header />

        <Tabs value={tab}>
          <Tabs.Panel value={EKindTab.GENERAL}>
            <TabGeneral />
          </Tabs.Panel>

          <Tabs.Panel value={EKindTab.ISSUES}>
            <Box mah={600} px='md' py='md' className={classes.topCard}>
              <TableBookingInsurances
                insurances={insurances?.insurance ?? [] as CoreInsurance[]}
                isLoading={isLoading}
              />
            </Box>
          </Tabs.Panel>
        </Tabs>
      </InsuranceProvider>
    </Modal>
  )
}
